import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.css';
const Footer = () => {
    const { t } = useTranslation('common');
    const currenteData = new Date();
  return (
    <footer className='ilo-footer-container'>
                <div className="container-fluid">
                    <div className="row d-md-flex justify-content-between">
                        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-3 footerSubbrandingContainer">
                            <a href="https://www.social-protection.org/gimi/ShowMainPage.action?ctx=0" rel="noreferrer" target="_blank">
                                <h1 className="footerTitle">{t('footer.title')}</h1>
                            </a>
                            <h2 className="footerSubtitle">{t('footer.descrption')}</h2>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 footerInfoContainer">
                            <h3 className="footerCollaboration">{t('footer.links_title')}</h3>
                            <ul className="footerList">
                                <li><a href="https://www.social-protection.org/gimi/WSPDB.action?id=32" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.link_dashboard')}</a></li>
                                <li><a href="https://www.social-protection.org/gimi/ShowPublications.action" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.link_publications')}</a></li>
                                <li><a href="https://www.social-protection.org/gimi/ShowWiki.action?id=7" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.link_tools')}</a></li>
                                <li><a href="https://www.social-protection.org/gimi/ContactForm.action" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.link_contact')}</a></li>

                            </ul>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 footerInfoContainer">
                            <ul className="footerListCopyRight">
                                <li>&copy; 1996-{currenteData.getFullYear()} {t('footer.copyright_title')}</li>
                                <li><a href="http://www.ilo.org/global/copyright/lang--en/index.htm" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.copyright_permissions')}</a></li>
                                <li><a href="http://www.ilo.org/global/privacy-policy/lang--en/index.htm" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.copyright_privacy')}</a></li>
                                <li><a href="http://www.ilo.org/global/disclaimer/lang--en/index.htm" rel="noreferrer" target="_blank" className="footerListElement">{t('footer.copyright_disclaimer')}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
  )
}

export default Footer;
